import { render, staticRenderFns } from "./sk-organization.vue?vue&type=template&id=9aa8381a"
import script from "./sk-organization.vue?vue&type=script&lang=js"
export * from "./sk-organization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports